function User3() {
  return (
    <svg
      width={114}
      height={114}
      data-testid="users-3-icon"
      viewBox="0 0 114 114"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={56.999} cy={57} r={56.585} fill="#fff" />
      <mask
        id="prefix__a"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={114}
        height={114}
      >
        <circle cx={56.999} cy={57} r={56.585} fill="#364542" />
      </mask>
      <g mask="url(#prefix__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M89.423 89.303c2.17 1.017 3.662 3.051 4.069 5.425 1.153 7.053 1.356 18.989 1.289 18.853H21.199s.204-11.936 1.424-18.989c.407-2.373 1.9-4.34 4.07-5.425 7.052-3.526 22.582-8.748 22.582-8.748v-5.087l-.407-.339c-2.983-2.238-5.018-5.696-5.628-9.426l-.068-.543h-.407c-2.374 0-4.408-1.492-5.29-3.594a6.278 6.278 0 01-.746-2.984c0-.678.136-1.424.407-2.102.136-.746.543-1.357 1.153-1.831l1.424-.814-.339-1.56c-2.577-11.258 6.104-21.43 17.904-21.702h1.695c11.733.272 20.413 10.444 17.972 21.838l-.34 1.56 1.425.813c.61.407 1.017 1.085 1.153 1.831.27.678.407 1.357.407 2.102 0 1.018-.34 2.103-.814 2.984-.882 2.103-2.916 3.595-5.29 3.595h-.475l-.067.542c-.61 3.73-2.645 7.189-5.63 9.427l-.474.339v5.086s15.53 5.222 22.583 8.749z"
          fill="#FFBF17"
        />
      </g>
    </svg>
  );
}

export default User3;
